<template>
    <CatTabs>
        <template #search-r>
            <CatSearch :searchHead="tableHead" @search="getdatas" v-model:searchForm='lookup.search'></CatSearch>
            <el-checkbox-group v-model="lookup.dataDimension" size="small" @change="dataDimensionC"
                v-if="dimension.length > 0 && dimensionType == 'checkbox'">
                <el-tooltip v-for="(item, index) in dimension" :key="index" :content="item+'维度统计'" placement="bottom"
                    effect="light">
                    <el-checkbox-button :key="index" :value="item">
                        {{item}}
                    </el-checkbox-button>
                </el-tooltip>
            </el-checkbox-group>
            <el-radio-group v-model="lookup.dataDimension" size="small" @change="dataDimensionC"
                v-if="dimension.length > 0 && dimensionType == 'radio'">
                <el-tooltip v-for="(item, index) in dimension" :key="index" :content="item+'维度统计'" placement="bottom"
                    effect="light">
                    <el-radio-button :label="item" :value="item" />
                </el-tooltip>
            </el-radio-group>
        </template>
        <template #search>
            <el-date-picker v-model="lookup.search.trade_date" type="daterange" range-separator="-"
                start-placeholder="开始时间" format="YYYY-MM-DD" value-format="YYYY-MM-DD" end-placeholder="结束时间"
                :disabled-date="disabledDate" @calendar-change='pickerOptions' :visible-change="timeOptionRange=''"
                v-if="searchH === 'date-picker'" @change="getdatas()" size="small" />
            <el-date-picker v-model="lookup.search.trade_date[1]" type="date" placeholder="选择时间" format="YYYY-MM-DD"
                value-format="YYYY-MM-DD" range-separator="-" v-else-if="searchH ===  'one-date-picker'"
                @change="getdatas" size="small" />
            <el-date-picker v-model="lookup.search.trade_date" type="monthrange" range-separator="~"
                value-format="YYYY-MM-DD" start-placeholder="开始月" end-placeholder="结束月"
                v-else-if="searchH === 'month-picker'" @change="getdatas" size="small" />
            <div v-else>未知快捷索引</div>
            <el-tooltip effect="light" v-if="manual" content="点击查看页面说明">
                <el-link :href="manual" target="_blank">
                    <el-icon style="font-size: 12px; color: bottom: ;">
                        <QuestionFilled />
                    </el-icon>
                </el-link>
            </el-tooltip>
        </template>
        <template #search-l>
            <el-button size="small" type="primary" @click="ExporttAPI('#table-data')">导出表
            </el-button>
        </template>
        <template #content>
            <CatTable v-model:fileList='fileList' :tableHead='tableHead' :lookup='lookup'
                @currentPage='v => lookup.currentPage = v' :loading='loading' />
        </template>
    </CatTabs>
</template>

<script>
    // @ is an alias to /src
    import CatTabs from '@/components/CatTabs.vue'
    import CatSearch from '@/components/CatSearch.vue'
    import CatTable from '@/components/CatTable.vue'
    //导出文件
    import jsonToExcel from '@/utils/jsonToExcel'
    import axios from "@/utils/request";
    import {
        mapState
    } from 'vuex'
    export default {
        name: 'dataScreen',
        components: {
            CatTabs,
            CatSearch,
            CatTable
        },
        created() {
            this.lookup.tabname = this.defaulturi
            this.lookup.search['trade_date'] = [this.today, this.today]
            this.getdatas()
        },
        watch: {
            $route() {
                this.handleClick(this.$route.query.id)
            }
        },
        computed: {
            ...mapState(['month', 'today', 'defaulturi']),
        },
        data() {
            return {
                dimension: ["销售", "小组", "品牌", "类目"],
                dimensionType: 'checkbox',
                tableHeight: 400,
                innerHeight: 0,
                activeNames: 0,
                searchH: null,
                tableHead: [],
                searchHead: [],
                lookup: {
                    tabname: '个人目标完成',
                    dataDimension: ["销售"],
                    search: {},
                    export: false,
                    currentPage: 1, //当前所在分页页数
                    pageSize: 20, //一页显示多少数据
                    total: 20, //总共有多少数据
                },
                manual: false,
                timeOptionRange: '',
                loading: false,
                fileList: [],
            }
        },
        methods: {
            pickerOptions(time) {
                //保存用户在设置日期选择器选择的第一个日期
                this.timeOptionRange = time[0];
            },
            disabledDate(time) {
                let dataOptionRange = this.timeOptionRange;
                let secondNum = 60 * 60 * 24 * 30 * 1000; // 时间跨度为30天【一年以365天的时间计算】的限制
                if (dataOptionRange) {
                    return time.getTime() > dataOptionRange.getTime() + secondNum || time.getTime() < dataOptionRange
                        .getTime();
                }
            },
            handleClick(v) { //切换菜单
                this.fileList.length = 0
                this.lookup.tabname = v
                if (!this.lookup.tabname.includes('月')) {
                    // 如果切换到不是月数据的表就限制日期为1天
                    this.lookup.search.trade_date[0] = this.lookup.search.trade_date[1]
                }
                this.dimension = []
                this.lookup.dataDimension = []
                const datadimension = JSON.parse(window.localStorage.getItem('datadimension'))
                if (datadimension) {
                    if (this.lookup.tabname in datadimension) {
                        this.lookup.dataDimension = datadimension[this.lookup.tabname]
                    }
                }
                this.getdatas()
            },
            getdatas() {
                this.loading = true
                // 判断是否为月数据
                let loTab = this.lookup.tabname
                let loSea = this.lookup.search
                if (loTab.includes('月')) {
                    // 若统计月的数据限制开始日期为月的第一天
                    let loDat = loSea.trade_date[loTab.includes('连续月') ? 0 : 1]
                    this.lookup.search.trade_date[0] = loDat.slice(0, -2) + '01'
                }
                this.dimensionType = 'checkbox'
                axios({
                    method: "post",
                    url: 'DataAnalyse',
                    data: this.lookup,
                }).then(res => {
                    if ('dataDimension' in res) {
                        this.dimension = res.dataDimension
                        this.lookup.dataDimension = res.useDimension
                        this.dimensionType = res.typeDimension
                    }
                    this.manual = "manual" in res ? res.manual : false
                    this.fileList = res.data
                    this.tableHead = res.tableHead
                    this.searchH = res.tableHead[0].type
                    this.loading = false
                })
            },
            ExporttAPI() { //导出表
                this.loading = true
                this.lookup.export = true
                let loD = this.lookup.dataDimension
                let title = typeof loD === "string" ? loD : loD.toString()
                jsonToExcel(this.fileList, this.tableHead, title + this.lookup.tabname)
                this.loading = false
                this.lookup.export = false
            },
            dataDimensionC() {
                if (this.lookup.dataDimension.length == 0) {
                    this.lookup.dataDimension = [this.dimension[0]]
                }
                let datadimension = JSON.parse(window.localStorage.getItem('datadimension'))
                if (!datadimension) {
                    datadimension = {}
                }
                datadimension[this.lookup.tabname] = this.lookup.dataDimension
                window.localStorage.setItem('datadimension', JSON.stringify(datadimension))
                this.getdatas()
            }
        }
    }
</script>

<style scoped>
    .el-form-item {
        width: 45%;
    }

    .el-menu-vertical-demo {
        height: 100%;
    }

    .el-menu {
        min-height: 415px;
    }

    .card-header {
        padding-left: 16px;
        margin-bottom: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .taheader {
        /* height: 700px; */
        padding-left: 16px;
        margin-bottom: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
</style>